import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import InfoCard from "../../Cards/InfoCard/InfoCard";

// images
import workIcon from "../../../images/career/work.png";
import learnIcon from "../../../images/career/learn.png";
import communityIcon from "../../../images/career/community.png";

// styles
import * as styles from "./WhatCanExpect.module.css";

const propTypes = {
  title: PropTypes.string,
  bottomText: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      iconAlt: PropTypes.string,
    })
  ),
};

const defaultProps = {
  title: "What You Can Expect at Twin Health",
  bottomText:
    "At Twin Health, every day is an opportunity to create something meaningful and impactful.",
  cards: [
    {
      icon: workIcon,
      title: "Dynamic Work Environment",
      description:
        "Collaborate with passionate, talented professionals in a fast-paced, innovative setting.",
      iconAlt: "Dynamic Work Environment",
    },
    {
      icon: learnIcon,
      title: "Opportunities to Learn and Grow",
      description:
        "Benefit from professional development programs, mentorship, and hands-on experience with cutting-edge technology.",
      iconAlt: "Opportunities to Learn and Grow",
    },
    {
      icon: communityIcon,
      title: "A Supportive Community",
      description:
        "Join a team that values trust, mutual respect, and collective success.",
      iconAlt: "A Supportive Community",
    },
  ],
};

const WhatCanExpect = ({ title, bottomText, cards }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className={styles.whatCanExpectWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Title */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
        </div>

        {/* Cards */}
        <div className={styles.cardsSection}>
          <InfoCard
            cards={cards}
            backgroundColor="#373049"
            columns={3}
            iconAlign="left"
          />
        </div>

        {/* Bottom Text */}
        <div className={styles.bottomSection}>
          <p className={styles.bottomText}>{bottomText}</p>
        </div>
      </div>
    </section>
  );
};

WhatCanExpect.propTypes = propTypes;
WhatCanExpect.defaultProps = defaultProps;

export default WhatCanExpect;
